module.exports = "/_next/static/images/visacardalt-89323e79cf7d0c401fd3241103c4f0c1.svg";